<template>
  <main-layout
    class="uplinkList"
    page-title="数据上链配置"
    custom-back
    @listen-back="goBack"
  >
    <div slot="main-content" class="main-content">
      <div class="title">
        <p>当前上链品种</p>
      </div>
      <div class="uplink-list">
        <div
          class="uplink-item"
          v-for="(item, index) in uplinkList"
          :key="index"
        >
          <div class="uplink-item-img"><img :src="item.imgUrl" alt="" /></div>
          <p class="crop-name">
            <span>{{ item.cropName }}</span>
          </p>
          <p class="end-date">
            截止时间：<span>{{ item.endDate | formatDate("yyyy.MM.dd") }}</span>
          </p>
          <div class="uplink-item-btn">
            <el-button type="primary" @click="editHandle(item.id, item.cropId)"
              >编辑</el-button
            >
            <el-button type="del" @click="delHandle(item.id)">删除</el-button>
          </div>
          <div class="snl-logo" v-if="!item.status">
            <img src="~@/assets/images/dataUplink/snlink-op.png" alt="" />
          </div>
        </div>
        <div class="uplink-new" @click="addNewHanle">
          <div class="new-add-icon">
            <i class="iconfont icon-jiajian-1"></i>
          </div>
          <p>添加品种</p>
        </div>
      </div>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from "@/layout/MainLayout";
import { getStorage } from "@/utils/storage";
import { getUplinkCropList, delUplinkCrop } from "@/api/request/snkd.produce";

export default {
  name: "uplinkList",
  components: {
    MainLayout,
  },
  data() {
    return {
      date: [],
      cropIds: [],
      total: 0,
      info: getStorage("FARMINFO"),
      uplinkList: [],
      pickerDateOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  mounted() {
    this.getUplinkCropList();
  },
  methods: {
    async getUplinkCropList() {
      try {
        const { farmId } = this.info;
        const res = await getUplinkCropList({
          farmId: farmId,
        });
        if (res.respCode === 0) {
          this.uplinkList = res.obj;
          this.cropIds = this.uplinkList
            .map((item) => {
              return item.cropId;
            })
            .join(",");
        }
      } catch (e) {
        console.log(e);
      }
    },
    // 返回上一页
    goBack() {
      window.history.go(-1);
    },
    //编辑
    editHandle(id, cropId) {
      console.log("cropId", cropId);

      this.$router.push({
        path: "/uplinkForm",
        query: {
          id: id,
          cropId: cropId,
          cropIds: this.cropIds,
        },
      });
    },
    //新增
    addNewHanle() {
      this.$router.push({
        path: "/uplinkForm",
        query: {
          cropIds: this.cropIds,
        },
      });
    },
    //删除
    delHandle(id) {
      const h = this.$createElement;
      this.$confirm("", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "confirm-dialog",
        message: h("div", [
          h(
            "p",
            {
              style:
                "font-size: 16px;margin-bottom:12px;color: rgba(0, 0, 0, 0.85);font-weight:400;",
            },
            `是否确定删除此上链配置？`
          ),
          h(
            "p",
            {
              style:
                "font-size: 14px;color: rgba(0, 0, 0, 0.65);font-weight:400;",
            },
            [h("span", null, "删除后的数据将无法恢复。")]
          ),
        ]),
        iconClass: "el-icon-warning",
      })
        .then(async () => {
          const res = await delUplinkCrop({
            id,
          });
          if (res.respCode === 0) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getUplinkCropList();
          }
        })
        .catch(() => {
          console.log("已取消");
        });
    },
  },
};
</script>

<style scoped lang="scss">
.uplinkList {
  .main-content {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    padding: 30px 24px;
    box-sizing: border-box;
    background: #fff;

    .title {
      margin: 0 auto;
      height: 50px;
      width: 150px;
      text-align: center;

      p {
        position: relative;
        font-size: 24px;
        font-weight: bold;
        color: #2e333b;
        line-height: 24px;
        z-index: 5;
        cursor: pointer;

        &::after {
          content: "";
          display: block;
          position: absolute;
          left: -2px;
          bottom: 0;
          width: 100%;
          padding: 0 2px;
          height: 8px;
          background: -webkit-gradient(
            linear,
            left top,
            right top,
            from(#64c3a4),
            to(#7cf9b3)
          );
          background: linear-gradient(90deg, #64c3a4, #7cf9b3);
          opacity: 0.4;
          border-radius: 4px;
          z-index: -1;
        }
      }
    }

    .uplink-list {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;

      .uplink-item {
        background-color: rgba(239, 243, 248, 0.5);
        margin: 0 10px;
        // width: calc((100% - 80px) / 5);
        width: 210px;
        height: 200px;
        border-radius: 20px;
        box-shadow: 0px 5px 20px 0px rgba(85, 85, 124, 0.13);
        padding: 15px;
        box-sizing: border-box;
        margin-bottom: 28px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;

        &-img {
          // background-color: pink;
          width: 70px;
          height: 70px;

          img {
            width: 70px;
            height: 70px;
            border-radius: 50%;
          }
        }

        &-btn {
          margin-top: 10px;
        }

        .snl-logo {
          position: absolute;
          top: 0;
          right: 0;
          width: 25px;
          height: 26px;
          background-color: #64c3a4;
          border-radius: 0px 10px;
          text-align: center;

          img {
            width: 15px;
            height: 18px;
            padding-top: 4px;
          }
        }

        .crop-name {
          margin-top: 10px;

          span {
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            font-size: 16px;
            font-weight: 400;
            color: #2e333b;
            padding: 2px 2px 2px 5px;
          }
        }
        .end-date {
          margin-top: 10px;
          font-size: 14px;
          font-weight: 400;
          color: #8490a2;
          span {
            font-size: 14px;
            font-weight: 400;
            color: #8490a2;
          }
        }
      }

      .uplink-new {
        border-color: rgba(239, 243, 248, 0.5);
        margin-right: 20px;
        width: 210px;
        height: 200px;
        border-radius: 20px;
        box-shadow: 0px 5px 20px 0px rgba(85, 85, 124, 0.13);
        padding: 15px;
        box-sizing: border-box;
        margin-bottom: 28px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        .new-add-icon {
          text-align: center;
          margin-bottom: 20px;

          i {
            font-size: 50px;
            color: #ccc;
          }
        }
      }

      // .uplink-item:nth-of-type(5n + 0) {
      //   margin-right: 0;
      // }
    }
  }

  ::v-deep .el-button {
    padding: 7px 20px !important;
  }

  ::v-deep .el-button--primary {
    color: #64c3a4 !important;
    background-color: #fff !important;

    &:hover {
      color: #fff !important;
      background-color: #64c3a4 !important;
    }
  }
  ::v-deep .el-button--del {
    color: #8490a2 !important;
    // background-color: #fff !important;

    &:hover {
      color: #fff !important;
      background-color: #64c3a4 !important;
    }
  }
}
</style>
